import React, {Component} from 'react';
import PasswordResetForm from "../../components/password-reset/PasswordResetForm";
import PasswordResetAuthForm from "../../components/password-reset-auth/PasswordResetAuthForm";


class PasswordReset extends Component {

  constructor(props) {
    super(props);
    this.props = props;
    this.state = {
      isAuthenticated: false,
      securityQuestionId: null,
      passwordResetToken: null
    };
  }

  onAuthenticatedForPasswordReset = (passwordResetToken) => {
    this.setState(
        {
          isAuthenticated: true,
          passwordResetToken: passwordResetToken
        }
    );
  };

  getFormContent = () => {
    if (this.state.isAuthenticated) {
      return (
          <PasswordResetForm {...this.props}
                             passwordResetToken={this.state.passwordResetToken}/>
      );
    } else {
      return (
          <PasswordResetAuthForm {...this.props}
                                 onAuthSuccess={this.onAuthenticatedForPasswordReset}/>
      );

    }
  };



  render() {
    return (this.getFormContent())
  };
}

export default PasswordReset;